import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9tvv55ca23r0tr1anp0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！我们会将最新资源推荐发送到您的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || '订阅失败，请稍后再试';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-16 bg-primary-500">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/20 mx-auto mb-4">
          <i className="ri-mail-send-line text-2xl text-background-50"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
          订阅资源更新
        </h2>
        <p className="text-background-200 text-sm mb-6">
          每周推送最新免费资源，不错过任何优质内容
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-readdy-form="">
          <div className="contact-alt-wrapper">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm border-0 outline-none focus:ring-2 focus:ring-background-300"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-foreground-950 text-background-50 rounded-lg font-medium hover:bg-foreground-800 transition-colors disabled:opacity-60 whitespace-nowrap text-sm"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {status === 'success' && (
          <p className="mt-3 text-sm text-background-100">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-3 text-sm text-background-100">{message}</p>
        )}
      </div>
    </section>
  );
}